
/*** script.js
 For handling and triggering the functionality of Photoswipe.
 This will enable the full screen viewing for cheerios image component.
 ***/
(function(window) {

  window.Cheerios = window.Cheerios || {};
  Cheerios.imageUtil = Cheerios.imageUtil || {};
  // Cheerios.imageUtil.checkIfImageIsLoaded = checkIfImageIsLoaded();

  var initPhotoFullScreenView = function(cheeriosImageSelector, iconSelector) {
    // parse slide data (url, title, size ...) from DOM elements
    // (children of cheeriosImageSelector)
    var parseImageElements = function(el) {
      var thumbElements = el.childNodes,
          numNodes = thumbElements.length,
          items = [],
          figureEl,
          imageEl,
          item;
      for (var i = 0; i < numNodes; i++) {
        figureEl = thumbElements[i]; // <figure> element
        // include only element nodes
        if (figureEl.nodeType !== 1) {
          continue;
        }
        imageEl = figureEl.getElementsByClassName("cmp-image__image")[0]; // <img> element
        // create slide object
        item = {
          src: imageEl.getAttribute('src'),
          w: imageEl.naturalWidth,
          h: imageEl.naturalHeight,
          msrc: imageEl.getAttribute('src')
        };
        item.title = imageEl.dataset.caption;
        item.el = figureEl; // save link to element for getThumbBoundsFn
        items.push(item);
      }
      return items;
    };
    // find nearest parent element
    var closest = function closest(el, fn) {
      return el && (fn(el) ? el : closest(el.parentNode, fn));
    };
    // triggers when user clicks on full screen icon
    var onFullScreenClick = function(e) {
      e = e || window.event;
      e.preventDefault ? e.preventDefault() : e.returnValue = false;
      var eTarget = e.target || e.srcElement;
      // find root element of slide
      var clickedListItem = closest(eTarget, function(el) {
        return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
      });
      if (!clickedListItem) {
        return;
      }
      // find index of clicked item by looping through all child nodes
      // alternatively, you may define index via data- attribute
      var clickedGallery = clickedListItem.parentNode,
          childNodes = clickedListItem.parentNode.childNodes,
          numChildNodes = childNodes.length,
          nodeIndex = 0,
          index;
      for (var i = 0; i < numChildNodes; i++) {
        if (childNodes[i].nodeType !== 1) {
          continue;
        }
        if (childNodes[i] === clickedListItem) {
          index = nodeIndex;
          break;
        }
        nodeIndex++;
      }
      if (index >= 0) {
        // open PhotoSwipe if valid index found
        openPhotoSwipe(index, clickedGallery);
      }
      return false;
    };
    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    var photoswipeParseHash = function() {
      var hash = window.location.hash.substring(1),
          params = {};
      if (hash.length < 5) {
        return params;
      }
      var vars = hash.split('&');
      for (var i = 0; i < vars.length; i++) {
        if (!vars[i]) {
          continue;
        }
        var pair = vars[i].split('=');
        if (pair.length < 2) {
          continue;
        }
        params[pair[0]] = pair[1];
      }
      if (params.gid) {
        params.gid = parseInt(params.gid, 10);
      }
      return params;
    };
    var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
      var pswpElement = galleryElement.querySelectorAll('.pswp')[0],
          gallery,
          options,
          items;
      items = parseImageElements(galleryElement);
      // define options (if needed)
      options = {
        // define gallery index (for URL)
        galleryUID: galleryElement.getAttribute('data-pswp-uid'),
        getThumbBoundsFn: function(index) {
          // See Options -> getThumbBoundsFn section of documentation for more info
          var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
              pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
              rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };
      // PhotoSwipe opened from URL
      if (fromURL) {
        if (options.galleryPIDs) {
          // parse real index when custom PIDs are used
          // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
          for (var j = 0; j < items.length; j++) {
            if (items[j].pid == index) {
              options.index = j;
              break;
            }
          }
        } else {
          // in URL indexes start from 1
          options.index = parseInt(index, 10) - 1;
        }
      } else {
        options.index = parseInt(index, 10);
      }
      // exit if index not found
      if (isNaN(options.index)) {
        return;
      }
      if (disableAnimation) {
        options.showAnimationDuration = 0;
      }
      // Pass data to PhotoSwipe and initialize it
      gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
    };
    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll(cheeriosImageSelector);
    var iconElements = document.querySelectorAll(iconSelector);
    for (var i = 0, l = galleryElements.length; i < l; i++) {
      galleryElements[i].setAttribute('data-pswp-uid', i + 1);
    }
    for (var j = 0, len = iconElements.length; j < len; j++) {
      iconElements[j].onclick = onFullScreenClick;
    }
    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash();
    if (hashData.pid && hashData.gid) {
      openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
    }
  };
  // execute above function 1st one is selector for images and second for full screen svg.
  var miliSecondsCounter = 0;
  const ATTEMPT_INTERVAL = 200;
  const MAX_MILI_SECONDS_TO_MAKE_ATTEMPT = 10000;
  var photoswipeImages = document.querySelectorAll(".cheerios--photoswipe-images");
  if (photoswipeImages && photoswipeImages.length > 0) {
    checkIfImageIsLoaded();
  }
  /**
   *   For Enabling Full Screen Functionality.
   *   Need to setup a particular markup for photoswipe to work.
   *   Adding Extra Markup To Image Through This Function.
   */
  function initPhotoSwipe() {
    var initImages = document.querySelectorAll(".cheerios--photoswipe-images");
    if(initImages && initImages.length > 0){
      initImages.forEach(function(elem){
        var figureElWrap =
            '<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject"></figure>';
        var imageEl = elem.querySelector('.cmp-image__image');
        // create wrapper container
        var wrapper = document.createElement('div');
        wrapper.className = "cheerios-img_tooltip";
        // insert wrapper before el in the DOM tree
        imageEl.parentNode.insertBefore(wrapper, imageEl);
        // move el into wrapper
        wrapper.appendChild(imageEl);
  
        var fullscreenEnabled = elem.getAttribute('data-full-screen-enabled'); 
        var nonTeaserImage = elem.closest(".image");

        if(fullscreenEnabled == "true" && nonTeaserImage){ 
          var fullScreenDiv = document.createElement('a');
          fullScreenDiv.className = "cheerios--open-close-fullscreen";
          fullScreenDiv.setAttribute("href", "#");
          fullScreenDiv.setAttribute("title", "Enter Full Screen");
          imageEl.parentNode.appendChild(fullScreenDiv);
        }          

        //// Handle Caption Divs
        ////
        ////
        ////
        // var captionEL = elem.querySelector('.cheerios-hidden-caption');
        // if(captionEL!=undefined){
        //   var popUpDiv = document.createElement('div');
        //   popUpDiv.className="cheerios-popupcaption";
        //   popUpDiv.innerHTML = captionEL.innerHTML;
        //   imageEl.parentNode.appendChild(popUpDiv);
        // }

        // add credit to the full screen 
        var creditVal = document.getElementsByClassName('photo-credit ');
        if (creditVal!=undefined){
          var fullScreenCredit = document.getElementsByClassName('pswp__credit__center');
          for (let i in fullScreenCredit){
            fullScreenCredit[i].innerHTML = creditVal[i].innerHTML;
          }
        }

        //Storing html of image element
        var innerHTML = elem.innerHTML;

        elem.innerHTML = "";

        //Creating figure element
        var figureElement = document.createElement('figure');
        figureElement.setAttribute("itemprop","associatedMedia");
        figureElement.setAttribute("itemprop","");
        figureElement.setAttribute("itemtype","http://schema.org/ImageObject");
        // Setting stored HTML of Image EL into Figure Element
        figureElement.innerHTML = innerHTML;
        elem.appendChild(figureElement);


      });
    }
    initPhotoFullScreenView('.cheerios--photoswipe-images', '.cheerios--open-close-fullscreen');
    // enableCaptionAsPopUp();
  }
  /**
   *   This function will add caption as pop up for all instances of cheerios image.
   */
  function enableCaptionAsPopUp() {
    var tooltips = document.querySelectorAll('.cheerios-img_tooltip .cheerios-popupcaption');
    window.onmousemove = function(e) {
      var x = (e.clientX + 20) + 'px',
          y = (e.clientY + 20) + 'px';
      for (var i = 0; i < tooltips.length; i++) {
        tooltips[i].style.top = y;
        tooltips[i].style.left = x;
      }
    };
  }
  /*
   * Here we are repeatedly calling this function until our image gets loaded
   * hence used a timeout function to check every 200 mili seconds
   * miliSecondsCounter is used to avoid the infinite loop.
   * because in the situations such as there are no image items
   * so to avoid infinite loop in such condition we used miliSecondsCounter here.
   */
  function checkIfImageIsLoaded() {
    var imagesLoaded = document.getElementsByClassName("cmp-image__image");
    document.addEventListener("DOMContentLoaded", function(e) {
      if (imagesLoaded && imagesLoaded.length > 0) {
        initPhotoSwipe();
      } 
    });
  }
})(window);
